"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var types = _interopRequireWildcard(require("./types"));
var _array = require("../../utils/array");
var _types2 = require("../session/types");
var _uniq = _interopRequireDefault(require("lodash/uniq"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  items: [],
  lastUpdatedAt: undefined,
  totalCountByCategory: {
    // context: count
  },
  unreadCountByCategory: {
    // context: count
  },
  currentCategory: undefined,
  loaded: false,
  error: undefined
};
var notificationReducer = function notificationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.SET_NOTIFICATIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: true,
        items: [...action._notifications]
      });
    case types.SET_NOTIFICATION_BY_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.category]: action._notifications
      });
    case types.ADD_NOTIFICATION_BY_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.category]: (0, _uniq.default)([...state[action.category], ...action._notifications])
      });
    case types.SET_LOADING_NOTIFICATION_COUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        ["".concat(action.category, "_loading")]: action.loading
      });
    case types.SET_NOTIFICATION_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentCategory: action.category
      });
    case types.SET_NOTIFICATION_COUNT_BY_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        totalCountByCategory: _objectSpread(_objectSpread({}, state.totalCountByCategory), {}, {
          [action.category || 'unknown']: action.count
        })
      });
    case types.SET_ALL_UNREAD_NOTIFICATION_COUNT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          unreadCountByCategory: _objectSpread(_objectSpread({}, state.unreadCountByCategory), action.allCount)
        });
      }
    case types.SET_UNREAD_NOTIFICATION_COUNT:
      return _objectSpread(_objectSpread({}, state), {}, {
        unreadCountByCategory: _objectSpread(_objectSpread({}, state.unreadCountByCategory), {}, {
          [action.category || 'unknown']: action.unreadCount
        })
      });
    case types.ADD_NEW_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: [action._notification, ...state.items]
      });
    case types.ADD_NEW_NOTIFICATION_BY_CATEGORY:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.category]: (0, _array.flatUniqConcat)([action._notification], state[action.category])
      });
    case types.WS_DELETE_NOTIFICATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: state.items.filter(_feed => _feed !== action.payload.id)
      });
    case _types2.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    default:
      return state;
  }
};
var _default = exports.default = notificationReducer;
module.exports = exports.default;